import request from '@/utils/request'

// eslint-disable-next-line no-unused-vars
function __type__() {
  /**
   * @typedef {{pageSize: number, currentPage: number}} PageRequest
   */
  // eslint-disable-next-line no-unused-vars
  function __type__PageRequest() {}

  /**
   * @template T
   * @typedef {{pageSize: number, currentPage: number, totalSize: number, totalPage: number, currentList: T[]}} PageResponse
   */
  // eslint-disable-next-line no-unused-vars
  function __type__PageResponse() {}

  /**
   * @template T
   * @typedef {{code: number, message: string, data: T, traceid: string}} R
   */
  // eslint-disable-next-line no-unused-vars
  function __type__R() {}

  /**
   * @typedef {{
   *   id?: number
   *   createTime?: string
   *   upateTime?: string
   *   channelGroupId?: string
   *   channelGroupName?: string
   *   level?: string
   *   module?: string
   *   system?: string
   * }} ChannelGroupRuleDTO
   */
  // eslint-disable-next-line no-unused-vars
  function __type__ChannelGroupRuleDTO() {}

  /**
   * @typedef {Omit<ChannelGroupRuleDTO, 'id'|'createTime'|'updateTime'>} ChannelGroupFindQuery
   */
  // eslint-disable-next-line no-unused-vars
  function __type__ChannelGroupFindQuery() {}

  /**
   * @typedef {Omit<ChannelGroupRuleDTO, 'id'|'createTime'|'updateTime'|'channelGroupName'>} ChannelGroupRuleSaveReq
   */
  // eslint-disable-next-line no-unused-vars
  function __type__ChannelGroupRuleSaveReq() {}
}

/**
 * 【通道组订阅规则】查询接口
 * @param {ChannelGroupFindQuery & PageRequest} params
 * @returns {Promise<R<PageResponse<{
 *   id: number,
 *   creatTime: string,
 *   updateTime: string,
 *   channelGroupId: string,
 *   channelGroupName: string,
 *   level: string,
 *   module: string,
 *   system: string
 * }>>>}
 */
export function findChannelGroupRule(params) {
  const { pageSize, currentPage, ...data } = params
  return request({
    url: `/channel-group-rule/find`,
    method: 'post',
    params: { pageSize, currentPage },
    data: data
  })
}

/**
 * 【通道组订阅规则】保存接口
 * @param {ChannelGroupRuleSaveReq} params
 * @returns {Promise<R<{id: number}>>}
 */
export function saveChannelGroupRule(params) {
  return request({
    url: `/channel-group-rule/save`,
    method: 'post',
    data: params
  })
}

/**
 * 【通道组订阅规则】删除接口
 * @param {{
 *   idList: number[]
 * }} params
 * @returns {Promise<R<void>>}
 */
export function deleteChannelGroupRule(params) {
  return request({
    url: `/channel-group-rule/delete`,
    method: 'post',
    data: params
  })
}
